import mfes from './mfes.json';

export const ENVS = [
  { name: 'k8s-aa', value: 'app-sm.k8s-aa.sm-qa.qa', key: 'aa' },
  { name: 'k8s-billing-dev', value: 'app-sm.k8s-billing-dev.sm-qa.qa', key: 'bd' },
  { name: 'k8s-billing', value: 'app-sm.k8s-billing.sm-qa.qa', key: 'b' },
  { name: 'k8s-cloudapi', value: 'app-sm.k8s-cloudapi.sm-qa.qa', key: 'c' },
  { name: 'app-qa', value: 'app-qa.qa', key: 'q' },
  { name: 'k8s-dev', value: 'app-sm.k8s-dev.sm-qa.qa', key: 'd' },
  { name: 'app-gcp', value: 'app-gcp.qa', key: 'gc' },
  { name: 'k8s-gh', value: 'app-sm.k8s-gh.sm-qa.qa', key: 'g' },
  { name: 'k8s-idm', value: 'app-sm.k8s-idm.sm-qa.qa', key: 'i' },
  { name: 'k8s-rdi', value: 'app-sm.k8s-rdi.sm-qa.qa', key: 'rdi' },
  { name: 'k8s-integration', value: 'app-sm.k8s-integration.sm-qa.qa', key: 'in' },
  { name: 'k8s-mw', value: 'app-sm.k8s-mw.sm-qa.qa', key: 'm' },
  { name: 'k8s-psc', value: 'app-sm.k8s-psc.sm-qa.qa', key: 'ps' },
  { name: 'k8s-rcp', value: 'app-sm.k8s-rcp.sm-qa.qa', key: 'r' },
  { name: 'k8s-auto', value: 'app-sm.k8s-auto.sm-qa.qa', key: 'au' },
  { name: 'production', value: 'app', key: 'p' },
  { name: 'staging', value: 'app-staging.qa', key: 's' }
];

export const MFE_LIST = Object.entries(mfes).map(([name, cfg]) => ({
  name,
  port: cfg.port
}));
